


































































































































































































































































































































	import { Vue, Component } from 'vue-property-decorator';
	import { Image } from '@/models/ImageModel';

    import ModalWindow from "@/components/Common/ModalWindow.vue";

	@Component({
		components: {
            ModalWindow,
		}
	})
	export default class DoubleTrPage extends Vue{
        private imageBaseUrl: string = "https://kursufa.ru/js/static/page/doubleTr/";

        private activeImage: string = "";
        private activeIndex: number = -1;
        private dialogVisible: boolean = false;

        private images: Image[] = [
            new Image("1s", "1"),
            new Image("2s", "2"),
            new Image("3s", "3"),
            new Image("4s", "4"),
        ]

        private getUrl(image: Image, full?: boolean){
            if(full){
                return `${this.imageBaseUrl}${image.Full}.jpg`
            }
            return `${this.imageBaseUrl}${image.Small}.jpg`
        }

        previewImage(image: Image){
            this.activeImage = this.getUrl(image, true);
            this.activeIndex = this.images.findIndex(x => x == image);
            this.dialogVisible = true;
        }

        prevSlide(){
            if(this.activeIndex != -1){
                let image = this.images[this.activeIndex - 1];

                if(image) this.previewImage(image);
            }
        }

        nextSlide(){
            if(this.activeIndex != -1){
                let image = this.images[this.activeIndex + 1];

                if(image) this.previewImage(image);
            }
        }

	}
